function estimateWidth(label) {
    const thinLetters = label.replace(/[^\sIiljtr,.]/g, '');
    const wideLetters = label.replace(/[^wWmM]/g, '');
    return label.length - (thinLetters.length - wideLetters.length) * 0.5;
}
/** Updates the width style property of the select dom element used for the scope selector.
 * Even though this is not a typically recommended pattern, considering how the screen space has to be efficiently managed
 * this could be considered as the better of the two problematic choices.
 */
export function updateWidth(selectDOM) {
    if (selectDOM) {
        const selectedOption = selectDOM.querySelector('option:checked');
        if (selectedOption && selectedOption.hasAttribute('label')) {
            // got the width of the selection
            const label = selectedOption.getAttribute('label') || '';
            // option.innerText is not supported by some jsdom environments.
            selectDOM.style.setProperty('width', `calc(${estimateWidth(label)}ch + 2.5rem)`);
        }
        else {
            // weird, let's remove the width override.
            selectDOM.style.removeProperty('width');
        }
    }
}
